
































import AbpBase from "../../lib/abpbase";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class Map extends AbpBase {
  // @Prop({
  //   type: Boolean,
  //   default() {
  //     return false;
  //   }
  // })
  show: boolean = false;
  mapCenter: any[] = [113.275342, 23.1227];
  searchOption: any = {
    city: "上海",
    citylimit: false
  };
  events: any = {
    click: e => {
      console.log(e);
      this.lnglathandler(e);
    }
  };
  plugin: any[] = [
    {
      pName: "ToolBar", //放大缩小工具
      events: {
        init(instance) {}
      }
    },
    {
      pName: "Scale", //比例尺
      events: {
        init(instance) {}
      }
    }
  ];

  lnglathandler(e) {
    let x = e.lnglat.getLng();
    let y = e.lnglat.getLat();
    (this as any).$emit("lnglatHandler", [x, y]);
  }
  onCloseMap() {
    // this.$emit("on-closeMap", false);
  }
  onSearchResult(pois) {
    console.log(pois);
    this.getlnglat(pois);
  }
  getlnglat(arr) {
    let latSum = 0;
    let lngSum = 0;
    //这就是我们封装的地图组件了，看到这基本上就完事了。
    let self = this;
    if (arr.length > 0) {
      arr.forEach(function(item, index) {
        let { lng, lat } = item;
        lngSum += lng;
        latSum += lat;
      });
      let center = {
        lng: lngSum / arr.length,
        lat: latSum / arr.length
      };
      this.mapCenter = [center.lng, center.lat];
      // console.log(this.mapCenter);
    }
  }
}
